import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function Database({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={3} question="How many patients are in your database?" options={[{
    label: 'Under 2,000',
    isDq: true
  }, {
    label: '2,001-5,000'
  }, {
    label: '5,001-10,000'
  }, {
    label: '10,000+'
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-148" />;
}